var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isLoading)?_c('div',{staticClass:"loading"},[_c('Loading',{staticClass:"loading__logo",attrs:{"v2":"","is-loading":_vm.isLoading}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }